<div class="card shadow-sm mx-auto" style="max-width: 600px;">
  <div class="card-header bg-primary text-white py-3">
    <h5 class="mb-0"><c-icon name="cil-user-follow" size="sm"></c-icon> Add New User</h5>
  </div>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="card-body p-4">
    <div class="row g-4">
      <div class="col-md-6">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="firstName" formControlName="first_name" placeholder="First Name">
          <label for="firstName">First Name</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="lastName" formControlName="last_name" placeholder="Last Name">
          <label for="lastName">Last Name</label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-floating mb-3">
          <select class="form-select" id="userType" formControlName="user_type" [disabled]="loading">
            <option value="" disabled selected>Select User Type</option>
            <ng-container *ngFor="let option of userTypeOptions">
              <option [value]="option.type">{{ option.type }}</option>
            </ng-container>
          </select>
          <label for="userType">User Type</label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-floating mb-3">
          <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email">
          <label for="email">Email</label>
        </div>
      </div>
      <ng-container *ngIf="!userId">
        <div class="col-md-12">
          <div class="form-floating mb-3 position-relative">
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" formControlName="password" placeholder="Password">
            <label for="password">Password</label>
            <div class="position-absolute top-0 end-0 mt-2 me-2 d-flex gap-1" style="z-index:2;">
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="suggestPassword()" title="Suggest Password">
                Suggest
              </button>
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="copyPassword()" title="Copy Password">
                Copy
              </button>
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="togglePasswordVisibility()" title="Show/Hide Password">
                {{ showPassword ? 'Hide' : 'Show' }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-floating mb-3">
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="passwordConfirmation" formControlName="password_confirmation" placeholder="Confirm Password">
            <label for="passwordConfirmation">Confirm Password</label>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="userId">
        <div class="col-md-6 d-flex align-items-center mb-3">
          <label class="me-3">Status:</label>
          <button type="button" class="btn btn-sm" [ngClass]="userForm.get('status')?.value ? 'btn-success' : 'btn-danger'" (click)="toggleStatus()">
            {{ userForm.get('status')?.value ? 'Active' : 'Deactivated' }}
          </button>
        </div>
      </ng-container>
    </div>
    <div class="mt-4 d-flex justify-content-end gap-2">
      <button type="submit" class="btn btn-primary btn-lg px-4" [disabled]="!isFormValid">
        <c-icon name="cil-user-follow" size="sm"></c-icon> {{ userId ? 'Update User' : 'Add User' }}
      </button>
      <c-spinner *ngIf="loading" class="text-black ms-2" variant="border" label="Loading..."></c-spinner>
    </div>
  </form>
</div>
